export const countriesData = [
  {
    code: 'cr',
    name: 'Costa Rica',
    dialCode: '+506',
    format: '(XXXX) XXXX',
    placeholder: '(8888) 8888',
    length: 8,
    padding: '50px',
  },
  // {
  //   code: 'in',
  //   name: 'India',
  //   dialCode: '+91',
  //   format: 'XXXXXXXXXX',
  //   placeholder: '9876543210',
  //   length: 10,
  //   padding: '40px'
  // },
  {
    code: 'us',
    name: 'United States',
    dialCode: '+1',
    format: '(XXX) XXX-XXXX',
    placeholder: '(123) 456-7890',
    length: 10,
    padding: '30px'
  },
  {
    code: 'es',
    name: 'Spain',
    dialCode: '+34',
    format: 'XXX XXX XXX',
    placeholder: '612 345 678',
    length: 9,
    padding: '40px'
  },
  // {
  //   code: 'pt',
  //   name: 'Portugal',
  //   dialCode: '+351',
  //   format: 'XXX XXX XXX',
  //   placeholder: '912 345 678',
  //   length: 9,
  //   padding: '50px'
  // }
];

export const getValidationForCountry = (country) => {
  return {
    pattern: new RegExp(`^\\d{${country.length}}$`),
    message: `${country.name} phone numbers must be ${country.length} digits`
  };
};

export const getCountryByCode = (code) =>
  countriesData.find(country => country.code === code);

export const DEFAULT_COUNTRY = countriesData[0];

export const statesByCountry = {
  cr: [
    { "code": "SJ", "name": "San José" },
    { "code": "AL", "name": "Alajuela" },
    { "code": "CA", "name": "Cartago" },
    { "code": "HE", "name": "Heredia" },
    { "code": "GU", "name": "Guanacaste" },
    { "code": "PU", "name": "Puntarenas" },
    { "code": "LI", "name": "Limón" }
  ],
  in: [
    { "code": "AP", "name": "Andhra Pradesh" },
    { "code": "AR", "name": "Arunachal Pradesh" },
    { "code": "AS", "name": "Assam" },
    { "code": "BR", "name": "Bihar" },
    { "code": "CG", "name": "Chhattisgarh" },
    { "code": "GA", "name": "Goa" },
    { "code": "GJ", "name": "Gujarat" },
    { "code": "HR", "name": "Haryana" },
    { "code": "HP", "name": "Himachal Pradesh" },
    { "code": "JH", "name": "Jharkhand" },
    { "code": "KA", "name": "Karnataka" },
    { "code": "KL", "name": "Kerala" },
    { "code": "MP", "name": "Madhya Pradesh" },
    { "code": "MH", "name": "Maharashtra" },
    { "code": "MN", "name": "Manipur" },
    { "code": "ML", "name": "Meghalaya" },
    { "code": "MZ", "name": "Mizoram" },
    { "code": "NL", "name": "Nagaland" },
    { "code": "OD", "name": "Odisha" },
    { "code": "PB", "name": "Punjab" },
    { "code": "RJ", "name": "Rajasthan" },
    { "code": "SK", "name": "Sikkim" },
    { "code": "TN", "name": "Tamil Nadu" },
    { "code": "TS", "name": "Telangana" },
    { "code": "TR", "name": "Tripura" },
    { "code": "UP", "name": "Uttar Pradesh" },
    { "code": "UK", "name": "Uttarakhand" },
    { "code": "WB", "name": "West Bengal" },
    { "code": "AN", "name": "Andaman and Nicobar Islands" },
    { "code": "CH", "name": "Chandigarh" },
    { "code": "DH", "name": "Dadra and Nagar Haveli and Daman and Diu" },
    { "code": "DL", "name": "Delhi" },
    { "code": "JK", "name": "Jammu and Kashmir" },
    { "code": "LA", "name": "Ladakh" },
    { "code": "LD", "name": "Lakshadweep" },
    { "code": "PY", "name": "Puducherry" }
  ],
  us: [
    { "code": "AL", "name": "Alabama" },
    { "code": "AK", "name": "Alaska" },
    { "code": "AZ", "name": "Arizona" },
    { "code": "AR", "name": "Arkansas" },
    { "code": "CA", "name": "California" },
    { "code": "CO", "name": "Colorado" },
    { "code": "CT", "name": "Connecticut" },
    { "code": "DE", "name": "Delaware" },
    { "code": "FL", "name": "Florida" },
    { "code": "GA", "name": "Georgia" },
    { "code": "HI", "name": "Hawaii" },
    { "code": "ID", "name": "Idaho" },
    { "code": "IL", "name": "Illinois" },
    { "code": "IN", "name": "Indiana" },
    { "code": "IA", "name": "Iowa" },
    { "code": "KS", "name": "Kansas" },
    { "code": "KY", "name": "Kentucky" },
    { "code": "LA", "name": "Louisiana" },
    { "code": "ME", "name": "Maine" },
    { "code": "MD", "name": "Maryland" },
    { "code": "MA", "name": "Massachusetts" },
    { "code": "MI", "name": "Michigan" },
    { "code": "MN", "name": "Minnesota" },
    { "code": "MS", "name": "Mississippi" },
    { "code": "MO", "name": "Missouri" },
    { "code": "MT", "name": "Montana" },
    { "code": "NE", "name": "Nebraska" },
    { "code": "NV", "name": "Nevada" },
    { "code": "NH", "name": "New Hampshire" },
    { "code": "NJ", "name": "New Jersey" },
    { "code": "NM", "name": "New Mexico" },
    { "code": "NY", "name": "New York" },
    { "code": "NC", "name": "North Carolina" },
    { "code": "ND", "name": "North Dakota" },
    { "code": "OH", "name": "Ohio" },
    { "code": "OK", "name": "Oklahoma" },
    { "code": "OR", "name": "Oregon" },
    { "code": "PA", "name": "Pennsylvania" },
    { "code": "RI", "name": "Rhode Island" },
    { "code": "SC", "name": "South Carolina" },
    { "code": "SD", "name": "South Dakota" },
    { "code": "TN", "name": "Tennessee" },
    { "code": "TX", "name": "Texas" },
    { "code": "UT", "name": "Utah" },
    { "code": "VT", "name": "Vermont" },
    { "code": "VA", "name": "Virginia" },
    { "code": "WA", "name": "Washington" },
    { "code": "WV", "name": "West Virginia" },
    { "code": "WI", "name": "Wisconsin" },
    { "code": "WY", "name": "Wyoming" },
    { "code": "DC", "name": "District of Columbia" },
    { "code": "AS", "name": "American Samoa" },
    { "code": "GU", "name": "Guam" },
    { "code": "MP", "name": "Northern Mariana Islands" },
    { "code": "PR", "name": "Puerto Rico" },
    { "code": "VI", "name": "U.S. Virgin Islands" }
  ],
  es: [
    { "code": "AN", "name": "Andalusia" },
    { "code": "AR", "name": "Aragon" },
    { "code": "AS", "name": "Asturias" },
    { "code": "IB", "name": "Balearic Islands" },
    { "code": "CN", "name": "Canary Islands" },
    { "code": "CB", "name": "Cantabria" },
    { "code": "CL", "name": "Castile and León" },
    { "code": "CM", "name": "Castile-La Mancha" },
    { "code": "CT", "name": "Catalonia" },
    { "code": "EX", "name": "Extremadura" },
    { "code": "GA", "name": "Galicia" },
    { "code": "MD", "name": "Community of Madrid" },
    { "code": "MC", "name": "Region of Murcia" },
    { "code": "NC", "name": "Navarre" },
    { "code": "PV", "name": "Basque Country" },
    { "code": "RI", "name": "La Rioja" },
    { "code": "VC", "name": "Valencian Community" },
    { "code": "CE", "name": "Ceuta" },
    { "code": "ML", "name": "Melilla" }
  ],
  pt: [
    { "code": "LIS", "name": "Lisbon" },
    { "code": "POR", "name": "Porto" },
    { "code": "BRG", "name": "Braga" },
    { "code": "SET", "name": "Setúbal" },
    { "code": "AVR", "name": "Aveiro" },
    { "code": "COI", "name": "Coimbra" },
    { "code": "FAR", "name": "Faro" },
    { "code": "EVO", "name": "Évora" },
    { "code": "GUI", "name": "Guimarães" },
    { "code": "VSE", "name": "Viseu" },
    { "code": "LEI", "name": "Leiria" },
    { "code": "FUN", "name": "Funchal" },
    { "code": "PDL", "name": "Ponta Delgada" },
    { "code": "VNG", "name": "Vila Nova de Gaia" },
    { "code": "SIN", "name": "Sintra" },
    { "code": "AMA", "name": "Amadora" },
    { "code": "ALM", "name": "Almada" },
    { "code": "BAR", "name": "Barreiro" },
    { "code": "MAT", "name": "Matosinhos" },
    { "code": "VDC", "name": "Viana do Castelo" }
  ]
};
// cr:spanish:[
//     { code: 'SJ', name: 'San José' },
//     { code: 'AL', name: 'Alajuela' },
//     { code: 'HE', name: 'Heredia' },
//     { code: 'CA', name: 'Cartago' },
//     { code: 'GU', name: 'Guanacaste' },
//     { code: 'PU', name: 'Puntarenas' },
//     { code: 'LI', name: 'Limón' }
//   ],
//es:spanish: [

// { "code": "AN", "name": "Andalucía" },
// { "code": "AR", "name": "Aragón" },
// { "code": "AS", "name": "Asturias" },
// { "code": "IB", "name": "Islas Baleares" },
// { "code": "CN", "name": "Canarias" },
// { "code": "CB", "name": "Cantabria" },
// { "code": "CL", "name": "Castilla y León" },
// { "code": "CM", "name": "Castilla-La Mancha" },
// { "code": "CT", "name": "Cataluña" },
// { "code": "EX", "name": "Extremadura" },
// { "code": "GA", "name": "Galicia" },
// { "code": "MD", "name": "Madrid" },
// { "code": "MC", "name": "Murcia" },
// { "code": "NC", "name": "Navarra" },
// { "code": "PV", "name": "País Vasco" },
// { "code": "RI", "name": "La Rioja" },
// { "code": "VC", "name": "Comunidad Valenciana" },
// { "code": "CE", "name": "Ceuta" },
// { "code": "ML", "name": "Melilla" }
// ],
// pt: spanish:
// [
//   { "code": "LIS", "name": "Lisboa" },
//   { "code": "POR", "name": "Oporto" },
//   { "code": "BRG", "name": "Braga" },
//   { "code": "SET", "name": "Setúbal" },
//   { "code": "AVR", "name": "Aveiro" },
//   { "code": "COI", "name": "Coímbra" },
//   { "code": "FAR", "name": "Faro" },
//   { "code": "EVO", "name": "Évora" },
//   { "code": "GUI", "name": "Guimarães" },
//   { "code": "VSE", "name": "Viseu" },
//   { "code": "LEI", "name": "Leiría" },
//   { "code": "FUN", "name": "Funchal" },
//   { "code": "PDL", "name": "Ponta Delgada" },
//   { "code": "VNG", "name": "Vila Nova de Gaia" },
//   { "code": "SIN", "name": "Sintra" },
//   { "code": "AMA", "name": "Amadora" },
//   { "code": "ALM", "name": "Almada" },
//   { "code": "BAR", "name": "Barreiro" },
//   { "code": "MAT", "name": "Matosinhos" },
//   { "code": "VDC", "name": "Viana do Castelo" }
// ]

// portugese:[
//   { "code": "LIS", "name": "Lisboa" },
//   { "code": "POR", "name": "Porto" },
//   { "code": "BRG", "name": "Braga" },
//   { "code": "SET", "name": "Setúbal" },
//   { "code": "AVR", "name": "Aveiro" },
//   { "code": "COI", "name": "Coimbra" },
//   { "code": "FAR", "name": "Faro" },
//   { "code": "EVO", "name": "Évora" },
//   { "code": "GUI", "name": "Guimarães" },
//   { "code": "VSE", "name": "Viseu" },
//   { "code": "LEI", "name": "Leiria" },
//   { "code": "FUN", "name": "Funchal" },
//   { "code": "PDL", "name": "Ponta Delgada" },
//   { "code": "VNG", "name": "Vila Nova de Gaia" },
//   { "code": "SIN", "name": "Sintra" },
//   { "code": "AMA", "name": "Amadora" },
//   { "code": "ALM", "name": "Almada" },
//   { "code": "BAR", "name": "Barreiro" },
//   { "code": "MAT", "name": "Matosinhos" },
//   { "code": "VDC", "name": "Viana do Castelo" }
// ]

